import React, { useEffect, useState, useRef } from 'react';
import '../styles/Map.css';

const Map = () => {
  const [error, setError] = useState(null);
  const mapContainer = useRef(null);
  const mapInstance = useRef(null);
  const geocoder = useRef(null);

  useEffect(() => {
    const loadKakaoMap = () => {
      if (document.querySelector('script[src*="kakao.maps"]')) {
        return new Promise((resolve) => {
          if (window.kakao?.maps?.LatLng) {
            resolve();
          } else {
            window.kakao.maps.load(() => {
              resolve();
            });
          }
        });
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_MAP_API_KEY}&libraries=services&autoload=false`;
        script.async = true;

        script.onload = () => {
          if (window.kakao && window.kakao.maps) {
            window.kakao.maps.load(() => {
              resolve();
            });
          } else {
            reject(new Error('카카오맵 SDK를 불러올 수 없습니다.'));
          }
        };

        script.onerror = () => {
          reject(new Error('카카오맵 스크립트를 불러올 수 없습니다.'));
        };

        document.head.appendChild(script);
      });
    };

    const initializeMap = () => {
      if (!mapContainer.current || mapInstance.current) return;

      try {
        if (!window.kakao?.maps?.LatLng) {
          setTimeout(initializeMap, 100);
          return;
        }

        const tempPosition = new window.kakao.maps.LatLng(37.3875, 126.9435);

        const options = {
          center: tempPosition,
          level: 3,
          draggable: true,
          scrollwheel: true,
          disableDoubleClickZoom: false,
          zoomControl: true,
        };

        const map = new window.kakao.maps.Map(mapContainer.current, options);
        mapInstance.current = map;

        geocoder.current = new window.kakao.maps.services.Geocoder();
        geocoder.current.addressSearch('경기도 안양시 동안구 시민대로 109번길 29', (result, status) => {
          if (status === window.kakao.maps.services.Status.OK) {
            const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);

            map.setCenter(coords);

            const marker = new window.kakao.maps.Marker({
              position: coords,
            });
            marker.setMap(map);
          } else {
            console.error('주소 검색 실패:', status);
            setError('주소를 찾을 수 없습니다.');
          }
        });
      } catch (error) {
        console.error('지도 초기화 중 오류 발생:', error);
        setError(error.message);
      }
    };

    loadKakaoMap()
      .then(() => {
        initializeMap();
      })
      .catch((error) => {
        console.error('카카오맵 로드 실패:', error);
        setError(error.message);
      });

    return () => {
      mapInstance.current = null;
      geocoder.current = null;
    };
  }, []);

  if (error) {
    return (
      <div className="map-container map-error-container">
        <div className="map-error-content">
          <div className="map-error-message">{error}</div>
          <small className="map-error-hint">
            잠시 후 다시 시도해주세요.
            <br />
            (새로고침이 필요할 수 있습니다)
          </small>
        </div>
      </div>
    );
  }

  return <div className="map-container" ref={mapContainer} />;
};

export default Map;
